import { render, staticRenderFns } from "./Gestisci.vue?vue&type=template&id=93296f60&"
import script from "./Gestisci.vue?vue&type=script&lang=js&"
export * from "./Gestisci.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports